import {
  FaLandmark,
  FaCreditCard,
  FaPowerOff,
  FaStore,
  FaPhone,
  FaScaleBalanced,
} from "react-icons/fa6";

const industries = [
  { label: "Banking and Financial Services", icon: <FaLandmark size={28} className="sm:w-10 sm:h-10" /> },
  { label: "Fintech", icon: <FaCreditCard size={28} className="sm:w-10 sm:h-10" /> },
  { label: "Enterprise Technology", icon: <FaPowerOff size={28} className="sm:w-10 sm:h-10" /> },
  { label: "Startups and Scale-ups", icon: <FaStore size={28} className="sm:w-10 sm:h-10" /> },
  { label: "Telecommunications", icon: <FaPhone size={28} className="sm:w-10 sm:h-10" /> },
  { label: "Public Sector", icon: <FaScaleBalanced size={28} className="sm:w-10 sm:h-10" /> },
];

const Industries = () => {
  return (
    <div className="w-full bg-blue-100 px-6 sm:px-10 xl:px-20 py-14 xl:py-20 flex flex-col items-center gap-12">
      {/* Header */}
      <div data-aos="fade-up" className="flex flex-col items-center gap-3 text-center">
        <h2 className="text-[28px] sm:text-[36px] xl:text-[40px] font-black text-white">
          Industries We Serve
        </h2>
        <p className="text-white/70 max-w-[520px] leading-relaxed">
          We deliver intelligent solutions across 6+ sectors, driving innovation
          and growth
        </p>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-4 sm:gap-x-8 gap-y-10 sm:gap-y-14 w-full max-w-[860px]">
        {industries.map((item, index) => (
          <div
            key={item.label}
            data-aos="fade-up"
            data-aos-delay={`${index * 100}`}
            className="flex flex-col items-center gap-3 sm:gap-5 text-center"
          >
            <span className="text-yellow-100">{item.icon}</span>
            <p className="text-white text-xs sm:text-sm md:text-base leading-snug">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Industries;
